<template>
  <div class="myTitle flex_between">
    <div class="img">
      <div class="breadcrumb">
        <div
          style="display:flex;align-items: center;"
          v-for="(item, index) in breadList"
          :key="index"
        >
          <span
            class="one"
            v-show="item.meta.grandFather"
            @click="toPath(item.meta.fatherPath)"
          >
            <span>{{ item.meta.grandFather }}</span>>
          </span>
          <span
            class="one"
            v-show="item.meta.father"
            @click="toPath(item.meta.fatherPath)"
          >
            <span>{{ item.meta.father }}</span>>
          </span>
          <span :class="index == breadList.length - 1 ? '' : 'one'">
            <span>{{ item.meta.title }}</span>
          </span>
          <span
            style="color:#000;"
            v-show="breadList.length > 1 && index != breadList.length - 1"
            >></span
          >
          <div v-show="query" style="display:flex;align-items: center;">
            <span v-show="pch">
              {{ pch }}
            </span>

            <span v-show="query.seeId">
              {{ ": " + query.seeId }}
            </span>

            <span v-show="query.claimantId">
              {{ ": " + query.claimantId }}
            </span>
            <span v-show="query.id">
              {{ ": " + query.id }}
            </span>
            <span v-show="query.questionNum">
              {{ ": " + query.questionNum }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadList: [], // 路由集合
      query: {},
      pch: ""
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
      this.getbreadParam();
    }
  },
  created() {
    this.getBreadcrumb();
    this.getbreadParam()
  },

  methods: {
    toPath(path) {
      if (path) {
        this.$router.push({ path: path });
      } else {
        return;
      }
    },
    getBreadcrumb() {
      this.breadList = [...this.$route.matched];
      this.breadList.shift();
      this.pch = sessionStorage.getItem("pch");
    },
    getbreadParam() {
      let _this = this;
      if (!_this.$route.meta.quality) {
        _this.$store.state.feedBackTotal = 0;
        _this.$store.state.feedBackPage = 1;
      }
      this.$nextTick(() => {
        Object.keys(_this.$route.query).length == 0
          ? (_this.query = false)
          : (_this.query = _this.$route.query);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.myTitle {
  height: 40px;
  display: flex;
  align-items: center;

  box-sizing: border-box;
  padding-left: 10px;
  border-bottom: 1px solid var(--border-color);

  .breadcrumb {
    display: flex;
    align-items: center;
  }
  // ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  // .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  // .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  // .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  //   color: #333;
  // }
  span > span {
    cursor: pointer;
    margin: 0 5px;
  }
  span > span:hover {
    color: var(--theme-color);
  }
  // span {
  //   cursor: pointer;
  // }
  // .one:hover {
  //   color: var(--theme-color);
  // }
}
</style>
